export default __webpack_public_path__ + "static/media/credit_card.895d009f.svg";